"use client";

import { useSyncExternalStore } from "react";
import { COLOR_MODE_BOOTSTRAP_SCRIPT } from "@/lib/theme/color-mode";

const subscribe = () => () => {};

/**
 * Инлайн-скрипт темы только на SSR (+ hydration snapshot).
 * На последующих клиентских рендерах — null, иначе React 19
 * ругается: «Encountered a script tag while rendering…».
 */
export function ColorModeBootstrap() {
  const shouldRender = useSyncExternalStore(subscribe, () => false, () => true);
  if (!shouldRender) return null;

  return (
    <script
      id="color-mode-bootstrap"
      dangerouslySetInnerHTML={{ __html: COLOR_MODE_BOOTSTRAP_SCRIPT }}
    />
  );
}
